var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-download-document-365592",
    transform: "translate(-49.2 -54.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4558",
    "data-name": "Raggruppa 4558",
    transform: "translate(49.2 54.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9568",
    "data-name": "Tracciato 9568",
    d: "M64.532,66.548,61.79,69.29V61.558a.667.667,0,0,0-.658-.658.634.634,0,0,0-.658.658V69.29l-2.742-2.742a.543.543,0,0,0-.768.768l3.729,3.729a.623.623,0,0,0,.439.165h0a.623.623,0,0,0,.439-.165L65.3,67.316a.543.543,0,0,0-.768-.768Z",
    transform: "translate(-52.632 -57.555)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9571",
    "data-name": "Tracciato 9571",
    d: "M57.7,54.8a8.5,8.5,0,1,0,8.5,8.5A8.507,8.507,0,0,0,57.7,54.8Zm4.168,9.761L58.139,68.29a.623.623,0,0,1-.439.165h0a.623.623,0,0,1-.439-.165l-3.729-3.729a.543.543,0,0,1,.768-.768l2.742,2.742V58.8a.667.667,0,0,1,.658-.658.634.634,0,0,1,.658.658v7.732L61.1,63.794a.543.543,0,0,1,.768.768Z",
    transform: "translate(-49.2 -54.8)",
    fill: "#255300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgDownload);
export default __webpack_public_path__ + "static/media/SvgDownload.140a983740da62d6adda9cbbbe014399.svg";
export { ForwardRef as ReactComponent };